import { resolveMediaUrl } from './mediaHelpers';

export const FALLBACK_REVIEWS = [];

export const mapReviewItem = (item) => ({
  id: item.documentId,
  quote: item.quote,
  name: item.clientName,
  title: item.clientTitle || '',
  photo: resolveMediaUrl(item.photo),
});
